SA.String = {
    getCodePointLength(string) {
        return SA.String.getCodePoints(string).length;
    },

    getCodePoints(string) {
        return Array.from(string);
    },

    isString(string) {
        return typeof string === 'string';
    },

    remove(string, substring) {
        return string.replace(substring, '');
    }
};